import React from 'react';

/**
 * Shared empty state component for consistent styling across pages.
 * Used when a page/section has no data to display.
 * 
 * @param {Object} props
 * @param {string} props.emoji - Large emoji to display (default: 🌱)
 * @param {string} props.title - Main message (e.g., "No seeds yet")
 * @param {string} props.subtitle - Secondary message (optional)
 * @param {Object} props.action - Optional action button { label: string, onClick: function }
 * @param {React.ReactNode} props.children - Optional custom content below subtitle
 */
const EmptyState = ({ 
  emoji = '🌱',
  title,
  subtitle,
  action,
  children
}) => {
  return (
    <div className="text-center py-16 bg-gray-50 rounded-2xl">
      <div className="text-5xl mb-4">{emoji}</div>
      <p className="text-gray-500 text-lg mb-2">{title}</p>
      {subtitle && (
        <p className="text-gray-400 text-sm mb-4">{subtitle}</p>
      )}
      {children}
      {action && (
        <button
          onClick={action.onClick}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#52A675] hover:bg-[#4A9168] text-white font-semibold rounded-xl transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
